import { createContext } from 'react'
import { initialStateProps, StoreAction } from './reducers'

interface IContextProps {
  state: initialStateProps
  dispatch: React.Dispatch<StoreAction>
}
// 创建 context
export const GlobalContext = createContext({} as IContextProps)
